'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import QHSEDashboard from './components/QHSEDashboard';

export default function QHSEPage() {
  return (
    <AppLayout currentPath="/qhse">
      <QHSEDashboard />
    </AppLayout>
  );
}
